import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="app-container">
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon">📡</div>
            <span>Telecom ERBs</span>
          </div>
        </div>
        
        <nav className="sidebar-nav">
          <div className="sidebar-section">Menu Principal</div>
          
          <NavLink 
            to="/" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
            end
          >
            <span className="sidebar-link-icon">📊</span>
            Dashboard
          </NavLink>
          
          <NavLink 
            to="/proprietarios" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="sidebar-link-icon">👤</span>
            Proprietários
          </NavLink>
          
          <NavLink 
            to="/imoveis" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="sidebar-link-icon">🏢</span>
            Imóveis
          </NavLink>
          
          <NavLink 
            to="/mapa" 
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="sidebar-link-icon">🗺️</span>
            Mapa
          </NavLink>
          
          {isAdmin() && (
            <>
              <div className="sidebar-section">Administração</div>
              
              <NavLink 
                to="/usuarios" 
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={closeSidebar}
              >
                <span className="sidebar-link-icon">👥</span>
                Usuários
              </NavLink>
            </>
          )}
        </nav>
        
        <div className="sidebar-user">
          <div className="sidebar-user-info">
            <div className="sidebar-user-avatar">
              {getInitials(user?.name || 'U')}
            </div>
            <div className="sidebar-user-details">
              <div className="sidebar-user-name">{user?.name}</div>
              <div className="sidebar-user-role">{user?.role}</div>
            </div>
          </div>
          <button 
            onClick={handleLogout}
            className="btn btn-sm btn-outline"
            style={{ marginTop: '12px', width: '100%', color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
          >
            🚪 Sair
          </button>
        </div>
      </aside>
      
      <main className="main-content">
        <Outlet />
      </main>
      
      <button 
        className="mobile-menu-btn"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>
      
      {sidebarOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 999
          }}
          onClick={closeSidebar}
        />
      )}
    </div>
  );
}

export default Layout;
